import React from 'react'
import propTypes from 'prop-types'

import styles from './styles.scss'


const Button = ( { children, size, color, ...resProps } ) => {
  return (
    <button 
      className={`
        ${styles['button']}
        ${styles[`button__size-${size}`]}
        ${styles[`button__color-${color}`]}
      `}
      {...resProps}
    >
      { children }
    </button>
  )
}

Button.propTypes = {
  /** color of button  */
  color: propTypes.string,
  /** size of button */
  size: propTypes.string
}

Button.defaultProps = {
  children: 'Button',
  color: 'primary',
  size: 'small'
}

export default Button


// WEBPACK FOOTER //
// ./src/components/Button/index.js